import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { AlertTriangle } from "lucide-react";

interface DealerReportButtonProps {
  onReportClick: () => void;
}

export function DealerReportButton({ onReportClick }: DealerReportButtonProps) {
  return (
    <Card>
      <CardContent className="p-4">
        <Button
          onClick={onReportClick}
          variant="outline"
          className="w-full flex items-center justify-center gap-2 text-red-600 border-red-200 hover:bg-red-50 hover:border-red-300 transition-colors"
        >
          <AlertTriangle className="h-4 w-4" />
          Segnala Compro Oro
        </Button>
      </CardContent>
    </Card>
  );
}
